export default "__VITE_PUBLIC_ASSET__cf4a0a6d__"